import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EquipoDto } from '../dto/justino/equipo.dto';
import { Constants } from '../constants/constants';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class EquiposService {
  private apiUrl = `${environment.justinoApiUrl}/api/teams/`;

  constructor(
    private http: HttpClient) {}

  getHeaders() {
    const authToken = sessionStorage.getItem(Constants.ACCESS_TOKEN) ?? '';   
    return { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    };
  }

  getEquipos(): Observable<EquipoDto[]> {
    return this.http.get<EquipoDto[]>(this.apiUrl, { headers: this.getHeaders() });
  }

  getEquipoById(id: string): Observable<EquipoDto> {
    return this.http.get<EquipoDto>(`${this.apiUrl}${id}`, { headers: this.getHeaders() });
  }
}
